import { ACTION_KEY } from '../shared-tools/types/shared-tools.types';

export enum ActionMesssages {
  HALL_PASS_BTN = 'Hall pass',
  CHECK_IN_BTN = 'Check in',
  ACTIVITY_BTN = 'Activity',
  PRAISE_BTN = 'Praise',
  GUIDANCE_BTN = 'Guidance',
  CONSEQUENCE_BTN = 'Consequence',
  REDEEM_POINTS_BTN = 'Redeem points',
  MANAGE_POINTS_BTN = 'Manage points',
  ASSIGN_BTN = 'Assign',
  POINTS_BTN = 'Points',
  SELF_CHECK_IN_BTN = 'Self check in',
  KIOSK_MODE_BTN = 'Kiosk mode',
}

export const ACTION_KEY_DEFAULTS: ACTION_KEY[] = [
  ACTION_KEY.CREATE_HALL_PASS,
  ACTION_KEY.CHECK_IN,
  ACTION_KEY.ASSIGN_ACTIVITY,
  ACTION_KEY.ASSIGN_PRAISE,
  ACTION_KEY.ASSIGN_GUIDANCE,
];
